export default "__VITE_ASSET__D24C97J$__"